export default class CampaignSummaryCtrl {
    constructor($scope, $timeout, $stateParams, $state, $filter, SideMenu, Campaign, Events, Setting, AbTest, SweetAlert, CurrentAccount, AccessHandler) {
        SideMenu.setActive('campaign');

        this._scope = $scope;
        this._dateFilter = $filter('date');
        this._translator = $filter('translate');
        this._state = $state;
        this._stateParams = $stateParams;
        this._timer = $timeout;
        this._filter = $filter;

        this.abTestRepo = AbTest;
        this.eventHandler = Events;
        this.alerter = SweetAlert;
        this.campaignRepo = Campaign;
        this.settingsRepo = Setting;
        this.currentAccount = CurrentAccount;
        this.accessHandler = AccessHandler;
        this.sweetAlert = SweetAlert;

        this.messageTypeIdToName = {
            1: 'email',
            2: 'text_message'
        };

        this.campaign = {
            validSender: true,
            validRecipients: true,
            validSubject: true
        };

        this.isScheduling = false;
        this.showAbTestSettings = true;
        this.showScheduler = true;
        this.showCampaignSettings = true;
        this.showExceededLimitCampaignInfo = false;

        this.userIsNotified = true;

        this.sendWhen();

        this.scheduled = {
            date: this._dateFilter(new Date(), 'yyyy-MM-dd')
        };

        this.time = {
            hour: moment().format('HH'),
            minutes: moment().add(5, 'minutes').format('mm')
        };

        this.minimumDate = this._dateFilter(new Date(), 'yyyy-MM-dd');

        this.campaignRepo.find(
            this._stateParams.id,
            this.constructor.getTypeId(this._stateParams.type)
        ).then((campaign) => {
            this.campaign = campaign.data;
            if (this._stateParams.type == 'email') {
                this.campaign.email = campaign.data.email.data;
            } else if (this._stateParams.type == 'text_message') {
                this.campaign.textMessage = campaign.data.textMessage.data;
            }

            this.to = this.concatenateRecipients();

            if (this.campaign.abTestActive) {
                this.abTestRepo.find(this.campaign.ab_test_id).then((response) => {
                    this.abTest = response.data;

                    this.abTestSubjects = '';

                    angular.forEach(this.abTest.campaigns, (campaign, index) => {
                        this.abTestSubjects += campaign.email.subject;

                        if (index != (this.abTest.campaigns.length) - 1) {
                            this.abTestSubjects += ', ';
                        }
                    });

                    if (this.abTest.ab_test_status_id == 3) {
                        this.campaign.abTestActive = false; // Don't show A/B-settings for winning A/B-campaign
                        this.campaign.abTestWinner = true;
                    } else {
                        this.abTest.send_winner = 1;

                        if (this.abTest.sample == 0) {
                            this.abTest.sample = 20;
                        }

                        if (this.abTest.minutes == 0) {
                            this.abTest.minutes = 60;
                        }

                        this.abTest.minutes = parseInt(this.abTest.minutes);

                        if (this.abTest.ab_test_winner_type_id == 0) {
                            this.abTest.ab_test_winner_type_id = 1;
                        }

                        if (this.abTest.ab_test_status_id == 4) {
                            this.setSchedulerType('scheduled');
                            this.abTestRepo.getSchedule(
                                this.abTest.id,
                                'scheduled'
                            ).then((schedule) => {
                                this.scheduled.date = schedule.date;
                                this.time = { hour: schedule.time.hour, minutes: schedule.time.minutes };
                            });
                        }
                    }
                });
            } else {
                if (this.campaign.campaign_status_id == 4) {
                    this.setSchedulerType('scheduled');

                    this.campaignRepo.getSchedule(this.campaign.id, 'scheduled', this.campaign.message_type_id).then((schedule) => {
                        this.scheduled.date = schedule.date;
                        this.time.hour = schedule.time.hour;
                        this.time.minutes = schedule.time.minutes;
                    });
                } else {
                    this.setSchedulerType('draft');
                }
            }

            this.campaignRepo.getRecipientCount(this.campaign.id).then(() => {
                this.pollCount(this.campaign.id);
            });
        });
    }

    get hasValidPaymentMethod() {
        return this.currentAccount?.data?.account?.card || this.currentAccount?.data?.account?.approved_for_invoice;
    }

    toggleAbSettings() {
        this.showAbTestSettings = ! this.showAbTestSettings;
    };

    toggleScheduler() {
        this.showScheduler = ! this.showScheduler;
    };

    toggleCampaignSettings() {
        this.showCampaignSettings = ! this.showCampaignSettings;
    };

    toSchedule() {
        // To prevent multiple calls to send engine.
        $('.campaign-send-btn').attr('disabled', true);

        let schedule = {
            campaign: this.campaign,
            schedulerType: this.schedulerType,
            date: this._dateFilter(this.scheduled.date, 'yyyy-MM-dd'),
            time: {
                hour: (+this.time.hour < 10 ? `0${+this.time.hour}` : this.time.hour),
                minutes: (+this.time.minutes < 10 ? `0${+this.time.minutes}` : this.time.minutes)
            },
            messageType: this.messageTypeIdToName[this.campaign.message_type_id]
        };

        if (! this.isScheduling) {
            this.isScheduling = true;

            if (this.campaign.abTestActive || this.campaign.abTestWinner) {
                this.abTest.minutes = this.abTest.minutes > 5 ? this.abTest.minutes : 5;
                this.abTest.minutes = this.abTest.minutes < 2880 ? this.abTest.minutes : 2880;
                if (this.schedulerType == 'draft') {
                    this.abTestRepo.saveDraft(this.abTest).then(() => {
                        this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:AB_TEST:FLASH:DRAFT_SAVED'));
                        this._scope.$emit('campaign:sentUpdate');
                        this._state.go('campaign.index', {}, { reload: true });
                    });
                } else if (this.schedulerType == 'now') {
                    if (this.campaign.abTestActive) {
                        this.abTestRepo.sendVersions(this.abTest).then(() => {
                            this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:AB_TEST:FLASH:SENT'));
                            this._scope.$emit('campaign:sentUpdate');
                            this._state.go('campaign.index', {}, { reload: true });
                        }, (error) => {
                            if (error.status == 400) {
                                this.alerter.swal({
                                    title: 'Error',
                                    text: this._translator('CAMPAIGN:AB_TEST:FLASH:VERSIONS_ERROR'),
                                    type: 'error'
                                });

                                this.isScheduling = false;
                            }
                        });
                    } else {
                        this.abTestRepo.sendWinner(this.abTest).then(() => {
                            this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:AB_TEST:FLASH:SENT'));
                            this._scope.$emit('campaign:sentUpdate');
                            this._state.go('campaign.index', {}, { reload: true });
                        }, (error) => {
                            this.alerter.swal({
                                title: 'Error',
                                text: this._translator('CAMPAIGN:AB_TEST:FLASH:WINNER_ERROR'),
                                type: 'error'
                            });

                            this.isScheduling = false;
                        });
                    }
                } else {
                    if (this.campaign.abTestActive) {
                        this.abTestRepo.scheduleVersions(this.abTest, this._dateFilter(this.scheduled.date, 'yyyy-MM-dd'), this.time).then(() => {
                            this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:AB_TEST:FLASH:SCHEDULED'));
                            this._scope.$emit('campaign:sentUpdate');
                            this._state.go('campaign.index', {}, { reload: true });
                        }, (error) => {
                            this.isScheduling = false;

                            if (error.status == 400) {
                                this.alerter.swal({
                                    title: 'Error',
                                    text: this._translator('CAMPAIGN:AB_TEST:FLASH:VERSIONS_ERROR'),
                                    type: 'error'
                                });
                            } else if (error.status == 405) {
                                this.alerter.swal({
                                    title: 'Error',
                                    text: this._translator('CAMPAIGN_SUMMARY_SCHEDULED:ERROR'),
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        this.abTestRepo.scheduleWinner(this.abTest, this._dateFilter(this.scheduled.date, 'yyyy-MM-dd'), this.time).then(() => {
                            this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:AB_TEST:FLASH:SCHEDULED'));
                            this._scope.$emit('campaign:sentUpdate');
                            this._state.go('campaign.index', {}, { reload: true });
                        }, (error) => {
                            this.isScheduling = false;

                            if (error.status == 405) {
                                this.alerter.swal({
                                    title: 'Error',
                                    text: this._translator('CAMPAIGN_SUMMARY_SCHEDULED:ERROR'),
                                    type: 'error'
                                });
                            }
                        });
                    }

                }
            } else {
                this.campaignRepo.setSchedule(schedule).then(() => {
                    this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:UPDATED'));
                    this._scope.$emit('campaign:sentUpdate');
                    this.isScheduling = false;
                    this._state.go('campaign.index', {}, { reload: true });
                }, (error) => {
                    if (error.status == 403) {
                        this.isScheduling = false;
                        this.alerter.swal({
                            title: 'Error',
                            text: this._translator('NOTIFICATION:SUBJECT:INVALID_URL'),
                            type: 'error'
                        });
                    } else {
                        this.isScheduling = false;
                        this.alerter.swal({
                            title: 'Error',
                            text: this._translator('CAMPAIGN_SUMMARY_SCHEDULED:ERROR'),
                            type: 'error'
                        });
                    }
                });
            }
        }
    };


    sendWhen() {
        if (this.schedulerType == 'scheduled') {
            return this._dateFilter(this.scheduled.date, 'longDate') + ' ' + this.time.hour + ":" + this.time.minutes;
        } else if (this.schedulerType == 'now') {
            return this._translator('CAMPAIGN:AB_SUMMARY:SCHEDULE_LABEL:NOW');
        } else {
            return this._translator('CAMPAIGN:AB_SUMMARY:SCHEDULE_LABEL:DRAFT');
        }
    };

    setSchedulerType(type) {
        this.schedulerType = type;
        this.sendWhen();
    };

    numSms() {
        return this.campaign.textMessage.content && this.getSMSLength() > 160 ? Math.ceil(this.getSMSLength() / 153) : 1;
    };

    getSMSLength() {
        var content = this.campaign.textMessage.content;
        return (content.replace(/[\t ]+/g, ' ').length + (this.stopMessage.length + 1) + this.shortenLinkCount());
    };

    shortenLinkCount() {
        let linkRegex = /([\w-]+:)?((https?):\/\/([a-z0-9]+[a-z0-9\-]*[a-z0-9]+(\.[a-z0-9\-]+)+)(\/[0-9a-z\-_.$%()]*)*([?|#]([\w\d=_\-$&%])*)*)/g;
        let longLinks, longLinksLength = 0, shortLinksLength = 0;

        if (linkRegex.test(this.campaign.textMessage.content)) {
            longLinks = this.campaign.textMessage.content.match(linkRegex);

            angular.forEach(longLinks, (link) => {
                longLinksLength += link.length;
            });

            shortLinksLength = longLinks.length * 25;
            return (shortLinksLength - longLinksLength);
        } else {
            return 0;
        }
    };

    totalCost() {
        this.totalSenderCost = (this.numSms() * 0.40 * this.campaign.totalRecipientCount).toFixed(2);
    };

    senderCostPerRecipient() {
        this.senderCostPerRecipient = (this.numSms() * 0.40).toFixed(2);
    };

    isTextMessage() {
        return this._stateParams.type == 'text_message';
    };

    static getType(campaign) {
        return campaign.message_type_id == 2 ? 'text_message' : 'email';
    };

    static getTypeId(type) {
        return type == 'text_message' ? 2 : 1;
    };

    pollCount(campaignId) {
        this._timer(() => {
            this.campaignRepo.pollRecipientCount(campaignId).then((response) => {
                if (response && response.state === 'finished') {
                    if (this.campaign.abTestWinner && this.abTest) {
                        let sampled = Math.ceil(response['count'] * (this.abTest.sample / 100));
                        this.campaign.totalRecipientCount = response['count'] - sampled;
                    } else {
                        this.campaign.totalRecipientCount = response['count'];
                    }

                    if (this.isTextMessage()) {
                        this.campaignRepo.getLatestTextMessageContent(campaignId).then((response) => {
                            this.campaign.textMessage.content = response.content.replace('%TextMessage:Stop%', '').trim();
                            this.campaign.textMessage.contentNotTrimmed = response.content.replace('%TextMessage:Stop%', '');

                            this.settingsRepo.findSenderDetail().then((details) => {
                                this.stopMessage = this.getStopWordByLanguage(details.text_message_stop);
                                this.totalCost();
                                this.senderCostPerRecipient();
                                this.numberSms = this.numSms();
                            });
                        });
                    }
                } else if (response && response.state === 'failed') {
                    this.campaign.totalRecipientCount = response['count'];
                    let textError = "";

                    switch(response.error) {
                        case 'missed_segment_parameter':
                            textError = this._filter('translate')('CAMPAIGN:SUMMARY:INVALID_SEGMENT');
                            break;
                        case 'missed_segment_tags':
                            textError = this._filter('translate')('CAMPAIGN:SUMMARY:MISSED_SEGMENT_TAG');
                            break;
                    }

                    return this.sweetAlert.swal({
                        title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                        text: textError,
                        type: "error"
                    });

                } else {
                    this.pollCount(campaignId);
                }
            });
        }, 3000);
    };

    goToEdit(campaign) {
        this._state.go('campaign.edit', { id: campaign.id, type: this.constructor.getType(campaign) });
    };

    static isValidUtm(utm) {
        return /^[a-zA-Z0-9_]*$/.test(utm);
    };

    concatenateRecipients() {
        var to = [];

        _.each(this.campaign.tags, (tag) => {
            to.push(tag.name);
        });

        _.each(this.campaign.segments, (segment) => {
            to.push(segment.name);
        });

        _.each(this.campaign.subscribers, (subscriber) => {
            to.push(subscriber.email);
        });

        return to.join(", ");
    };

    updateTrackingCampaignCode(campaign) {
        if (! this.constructor.isValidUtm(campaign.email.ga_utm_campaign)) {
            return this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:SUMMARY:TRACKING_ERROR'));
        }

        this.campaignRepo.setTrackingCampaignCode(campaign.id, campaign.email.id, campaign.email.ga_utm_campaign).then((response) => {
            campaign.email.ga_utm_campaign = response.utm;
            this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:SUMMARY:TRACKING_SUCCESS'));
        });
    };

    updateTrackingTermCode(campaign) {
        this.campaignRepo.setTrackingTermCode(campaign.id, campaign.email.id, campaign.email.ga_utm_term).then((response) => {
            campaign.email.ga_utm_term = response.utm;
            this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:SUMMARY:TRACKING_SUCCESS'));
        });
    };

    getStopWordByLanguage(stopMessage) {
        try {
            let langEl = $(stopMessage).filter('[data-language=' + this.campaign.textMessage.language.data.code + ']')[0];
            return $(langEl).text();
        } catch (error) {
            return stopMessage;
        }
    }

    validRecipientCount() {
        this.validRecipientCountMessage = '';

        let isEmailMessage = this.messageTypeIdToName[this.campaign.message_type_id] == 'email';
        let isTextMessage =  this.messageTypeIdToName[this.campaign.message_type_id] == 'text_message';

        if (this.currentAccount.sendCount().unlimited) {
            return true;
        } else if (this.campaign.totalRecipientCount === undefined) {
            this.validRecipientCountMessage = this._translator('CAMPAIGN:SUMMARY:RECIPIENTS_COUNT_ERROR_1');
            return false;
        } else if (this.campaign.totalRecipientCount === 0) {
            this.validRecipientCountMessage = this._translator('CAMPAIGN:NO_RECIPENTS_ERROR');
            return false;
        } else if (this.currentAccount.sendCount().remaining - this.campaign.totalRecipientCount >= 0) {
            return true;
        } else if (this.hasValidPaymentMethod && this.currentAccount.data.account.soft_limit) {
            return true;
        }

        if (isEmailMessage) {
            if (this.hasValidPaymentMethod) {
                this.validRecipientCountMessage = this._translator('CAMPAIGN:SUMMARY:RECIPIENTS_COUNT_ERROR_2');
                this.showExceededLimitCampaignInfo = true;
                this.exceededLimitText = {}
            } else {
                this.showExceededLimitCampaignInfo = true;
                this.validRecipientCountMessage = this.accessHandler.hasRole(['Super Admin']) ?
                    this._translator('CAMPAIGN:SUMMARY:RECIPIENTS_COUNT_ERROR_3') :
                    this._translator('CAMPAIGN:SUMMARY:RECIPIENTS_COUNT_ERROR_4');
            }
          //Text messages has no limits
        } else if (isTextMessage && this.hasValidPaymentMethod) {
            return true;
        }

        return false;
    }

    setWinnerUtm(utm) {
        if (! this.constructor.isValidUtm(utm)) {
            return this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:SUMMARY:TRACKING_ERROR'));
        }
        this.abTest.winner_utm = utm;
        this.abTestRepo.setWinnerUtm(this.abTest)
    }
};
